'use strict';
require('./warnAboutDeprecatedCJSRequire.js')('createMemoryHistory');
module.exports = require('./index.js').createMemoryHistory;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/history/createMemoryHistory.js
// module id = 538
// module chunks = 99